<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 12"
    fill="none"
    v-bind="$attrs"
    :width="width"
    :height="height"
  >
    <path d="M0 5H12V7H0V5ZM0 0H16V2H0V0ZM0 12H7.235V10H0V12Z" :fill="fill" />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 16,
  },
  height: {
    type: [String, Number],
    default: 12,
  },
  fill: {
    type: String,
    default: 'currentColor',
  },
});
</script>
